import "./booking.css";

import React from "react";

import { PAGE_ROUTES } from "../../utils/stateTypes";
import SEO_DATA from "../../utils/seoData";
import SeoHead from "../general/SeoHead";


const Booking = () => {

  React.useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://embed.bookem.com/embed.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  React.useEffect(() => {
    const updateShadowRoot = () => {
      //Hide the long description under each item (inject style into the shadow root created by bookem-widget)
      const style = document.createElement("style");
      style.innerHTML = `
        .bkm-1gpr7t5 {
          display: none;
        }
      `;

      const shadowRoot = document.querySelector("bookem-widget").shadowRoot;
      if (shadowRoot) {
        shadowRoot.appendChild(style);
      }
      else {
        setTimeout(updateShadowRoot, 100);
      }
    };

    updateShadowRoot();
  }, []);

  return (
    <main>
      <SeoHead
        {...SEO_DATA[PAGE_ROUTES.BOOK]}
        path={PAGE_ROUTES.BOOK}
      />

      {/* <img
        src={"/images/contact/header-bg2.webp"}
        className={"booking-header-img"}
        alt={"Ash The Dietitian Book a Consultation Header"}
      />

      <header className={"standard-width"}>
        <h1 className={"section-head"}>Book a consultation</h1>
      </header> */}

      <header className={"booking-header"}>
        <div className={"standard-width"}>
          <div className={"booking-header-content"}>
            <h1>Ready to book?</h1>
            <p>Reserve  <i>your session</i> with Ash the Dietitian below. </p>
            <p className={"line-two"}>Select from the list below, and book your spot.</p>
          </div>
        </div>
        <img
          src={"/images/contact/header-bg2.webp"}
          className={"booking-header-img"}
          alt={"Book with Ash The Dietitian - Cape Town & Online Dietitian"}
        />
      </header>



      <section className={"booking-section standard-width"}>
        <div className={"booking-note"}>
          <p>When booking an initial consultation, don't forget to also book in your Meal Plan Collection session within 3 days after the Initial Consultation.</p>
          <p><b>Reminder:</b> our Johannesburg branch is an online practice with an inbody weigh-in facility.</p>
        </div>
        <bookem-widget business-id={"fcd2c1ef9e524f7fac3106260eeacf8d"} />
      </section>
    </main>
  );
};

export default Booking;

